import en from './en-US.json'
import zh from './zh-CN.json'

export const locals =  {
    en: {...en},
    zh: {...zh},
}

/**
 * CAS 认证中心地址与回调地址（与后端 application-pro.yml 的 cas.server-url-prefix / cas.service 保持一致）
 * 登录过期(401)时跳转 CAS 登录页，登录成功后 CAS 会带 ticket 回调到 CAS_SERVICE_URL
 */
export const CAS_SERVER_URL_PREFIX = "https://cas.sustech.edu.cn/cas";
export const CAS_SERVICE_URL = "https://sdsfpt.sustech.edu.cn/login/";
export const CAS_LOGIN_URL = `${CAS_SERVER_URL_PREFIX}/login?service=${encodeURIComponent(CAS_SERVICE_URL)}`;


